export const actionTypes: any = {
  // Get Municipality
  GET_MUNICIPALITY_START: 'GET_MUNICIPALITY_START',
  GET_MUNICIPALITY_SUCCESS: 'GET_MUNICIPALITY_SUCCESS',
  GET_MUNICIPALITY_FINISH: 'GET_MUNICIPALITY_FINISH',
}
